/*
 * 30-09-2026 Swiss-Relax: eerste leverdatum in de USP-tegel van de categorie-overzichten
 * (sections/sr-category-overview.liquid, eerste tegel "In ± 4 dagen thuis").
 *
 * De datum komt uit Buunto via assets/levering-dates.js (window.SwissRelaxDelivery),
 * dus dezelfde regels als de datumkiezer: leverdagen, eerste beschikbare dag, geblokkeerde datums.
 * Eerst wordt de vaste tekst "1 tot 3 werkdagen" gezet; zodra Buunto geladen is, komt de echte datum.
 * Geladen vanuit layout/theme.liquid, enkel op pages. Doet niets op pagina's zonder die tegel.
 */
(function () {
  'use strict';

  var LOC = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var FALLBACK = {
    nl: 'In 1 tot 3 werkdagen thuis',
    fr: 'Chez vous en 1 à 3 jours ouvrables',
    de: 'In 1 bis 3 Werktagen bei Ihnen',
    en: 'Home in 1 to 3 working days'
  };
  var PRE = {
    nl: 'Al thuis op ',
    fr: 'Chez vous dès le ',
    de: 'Bei Ihnen ab ',
    en: 'At your home from '
  };

  function tiles() {
    return document.querySelectorAll('.sr-cat__usps .sr-cat__usp:first-child b');
  }

  function setText(txt) {
    Array.prototype.forEach.call(tiles(), function (el) { el.textContent = txt; });
  }

  function fillDate() {
    var api = window.SwissRelaxDelivery;
    if (!api) { return false; }
    var d = api.nextDates(1);
    if (!d) { return false; }
    var opts = { weekday: 'short', day: 'numeric', month: 'short' };
    var txt;
    try { txt = d[0].toLocaleDateString(LOC + '-BE', opts); }
    catch (e) { txt = d[0].toLocaleDateString('nl-BE', opts); }
    setText((PRE[LOC] || PRE.nl) + txt);
    return true;
  }

  function init() {
    if (!tiles().length) { return; }
    setText(FALLBACK[LOC] || FALLBACK.nl);
    if (fillDate()) { return; }
    // Buunto is een app embed en kan na ons laden.
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (fillDate() || tries > 20) { clearInterval(timer); }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();